import { AjustageContexte } from "./ajustage-context";
import { EMasterSondeType } from "./enum/master-sonde-type";

export class MasterSonde {
    public Code: string;
    public Type: EMasterSondeType;
    public Reference: string;
    //** Formula */
    public FacteurCorrection: string;
    public IsActive: boolean;

    /** Only ONLINE */
    AjustageContexteList?: AjustageContexte[] = []

    static mapFromJSON(json: any): MasterSonde {
        const ms = new MasterSonde();
        ms.Code = json.code;
        ms.Type = json.type;
        ms.Reference = json.reference;
        ms.FacteurCorrection = json.facteurCorrection;
        ms.IsActive = json.isActive;

        if (json.ajustageContexteList) {
            ms.AjustageContexteList = json.ajustageContexteList.map(jsonItem => AjustageContexte.mapFromJSON(jsonItem));
        }

        return ms;
    }
}